import classNames from 'classnames'
import { type ChangeEvent } from 'react'

import { BlurApp, Button, CenteredBlock, Icon } from '@/shared'
import { type IFaqEditAction, type IEditFaq, type IFaqData } from '@App/types/faqTypes'
import { EIcons } from '@App/types/iconType'

import { EditableSpan } from './EditableSpan/EditableSpan'
import style from './FaqItem.module.scss'

interface IProps extends IEditFaq {
    list: IEditFaq[]
    dto: IFaqData[]
    onHandleIsEditClose: (id: string, isEdit: boolean) => void
    onOpenEdit: () => void
    setFaqEditableState: (data: IEditFaq[] | null) => void
    updateFaqList: (dto: IFaqData) => void
    removeFaqById: (faqId: string) => void
    onDragStartHandler: (e: any, item: IEditFaq) => void
    onDragLeaveHandler: (e: any, id: string) => void
    onDragEndHandler: (e: any) => void
    onDragOverHandler: (e: any, id: string) => void
    onDropHandler: (e: any, item: IEditFaq) => void
    highlited: string | null
}

export const FaqItem = (props: IProps) => {
    const {
        header,
        title,
        id,
        createAt,
        sequence,
        isEdit,
        dto,
        list,
        onHandleIsEditClose,
        onOpenEdit,
        setFaqEditableState,
        updateFaqList,
        removeFaqById,
        onDragStartHandler,
        onDragLeaveHandler,
        onDragEndHandler,
        onDragOverHandler,
        onDropHandler,
        highlited
    } = props

    const hasEmptyFields = header === '' || title === ''

    const actions: IFaqEditAction[] = [
        { title: 'Сохранить', code: 'update', color: 'blue', disabled: hasEmptyFields },
        { title: 'Удалить', code: 'remove', color: 'red', disabled: false }
    ]

    const onCloseEdit = () => onHandleIsEditClose(id, !isEdit)

    const onSetChangedValue = (value: string, id: string, prop: 'header' | 'title') =>
        setFaqEditableState(list.map((item) => (item.id === id ? { ...item, [prop]: value } : item)))

    const onChangeHeader = (e: ChangeEvent<HTMLTextAreaElement>) => onSetChangedValue(e.target.value, id, 'header')
    const onChangeTitle = (e: ChangeEvent<HTMLTextAreaElement>) => onSetChangedValue(e.target.value, id, 'title')

    const controlCn = classNames(style.controlWrapper, isEdit ? style.edit : style.read)

    return (
        <div
            className={classNames(
                style.container,
                highlited === id && style.highlitedContainer,
                isEdit && style.bluredContainer
            )}
            onDragStart={(e: any) => onDragStartHandler(e, { id, header, title, createAt, isEdit, sequence })}
            onDragLeave={(e: any) => onDragLeaveHandler(e, id)}
            onDragEnd={(e: any) => onDragEndHandler(e)}
            onDragOver={(e: any) => onDragOverHandler(e, id)}
            onDrop={(e: any) => onDropHandler(e, { id, header, title, createAt, isEdit, sequence })}
            draggable
        >
            <BlurApp show={isEdit} withScroll />
            <div className={style.contentWrapper}>
                <EditableSpan value={header} isEdit={isEdit} onChange={onChangeHeader} className={style.header} />
                <EditableSpan value={title} isEdit={isEdit} onChange={onChangeTitle} className={style.title} />
                {isEdit && (
                    <div className={style.actions}>
                        {actions.map(({ title, code, color, disabled }) => {
                            const onClickHandler = () => {
                                switch (code) {
                                    case 'update':
                                        updateFaqList(dto.filter((el) => el.id === id)[0])
                                        break
                                    case 'remove':
                                        removeFaqById(id)
                                        break
                                    default:
                                        return () => {}
                                }
                            }
                            return (
                                <Button
                                    key={title}
                                    className={classNames(style.btn, style[color])}
                                    onClick={onClickHandler}
                                    disabled={disabled}
                                >
                                    {title}
                                </Button>
                            )
                        })}
                    </div>
                )}
            </div>
            <CenteredBlock className={controlCn} onClick={isEdit ? onCloseEdit : onOpenEdit}>
                <Icon iconName={isEdit ? EIcons.CLOS : EIcons.PEN} color='#557dfb' />
            </CenteredBlock>
        </div>
    )
}
